import { AxiosInstance } from 'axios'

import {
  CreateEmployeesIdentificationsRequest,
  UploadEmployeeIdentificationFileRequest,
} from '@modules/employees/types/EmployeesIdentifications/requests'
import { EmployeePerson } from '@modules/employees/types/EmployeesPersons/employeesPersons'

export class EmployeesIdentificationsService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async create(data: CreateEmployeesIdentificationsRequest): Promise<EmployeePerson> {
    const { employeeId, ...body } = data

    const response = await this.instance.post(`/companies/employees/${employeeId}/identifications`, body)

    return response.data
  }

  async uploadFile({ employeeId, file }: UploadEmployeeIdentificationFileRequest): Promise<EmployeePerson> {
    const formData = new FormData()
    formData.append('file', file)

    const response = await this.instance.post(`/companies/employees/${employeeId}/identifications/file`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })

    return response.data
  }
}

export const employeesIdentificationsService = (instance: AxiosInstance) =>
  new EmployeesIdentificationsService(instance)
